export interface IStore {
    session: any;
    agencias: any[];
}

export const StoreInitState: IStore = {
    session: null,
    agencias: []
}
